import React from 'react';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import '../assets/css/CategorySection.css';
import product1 from '../assets/images/psoriasis.gif';
import product2 from '../assets/images/Antifungal.gif';
import product3 from '../assets/images/Health-to-hair.gif';
import product4 from '../assets/images/pigmentation.gif';
import product5 from '../assets/images/Acne.gif';
import product6 from '../assets/images/Antiallergic.gif';
import product7 from '../assets/images/Sun-protection.gif';
import product8 from '../assets/images/Moisturizer.gif';

const CategorySection = () => {
    const categories = [
        { name: 'Psoriasis', img: product1, link: '/Skin-Care-Products?sub=Psoriasis' },
        { name: 'Antifungal', img: product2, link: '/Skin-Care-Products?sub=Anti-Fungal' },
        { name: 'Health to Hair', img: product3, link: 'HairCareProducts' }, // ✅ updated
        { name: 'Pigmentation', img: product4, link: '/Skin-Care-Products?sub=Pigmentation' },
        { name: 'Acne', img: product5, link: '/Skin-Care-Products?sub=Acne' },
        { name: 'Antiallergic', img: product6, link: '/Skin-Care-Products?sub=Anti-Allergic' },
        { name: 'Sun Protection', img: product7, link: '/Skin-Care-Products?sub=Photoprotection' },
        { name: 'Moisturizer', img: product8, link: '/Skin-Care-Products?sub=Skin Soothing' },
    ];

    const navigate = useNavigate();

    return (
        <section className="category-section">
            {categories.map((item, index) => (
                <div
                    className="category-card"
                    key={index}
                    onClick={() => navigate(item.link)} // ✅ navigate on click
                >
                    <div className="icon-wrapper">
                        <img src={item.img} alt={item.name} />
                    </div>
                    <p className="category-name">{item.name}</p>
                </div>
            ))}
        </section>
    );
};


export default CategorySection;



